import { curry, type PlatformEvent } from 'lib/util'
import listBatteryStatus from 'app/_shared/events/collection/bluetooth/listBatteryStatus'
import { BatteryStatus } from 'model/_shared/collection/bluetooth/battery'
import { GET_STAT } from 'app/xEcoApm/helper/apm'

/**
 * Get Battery Status
 *
 * Attempts to retrieve the battery status from the current sensor model, whose key must match that
 * of a paired Bluetooth peripheral.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 * @returns         current battery status or null
 */
const getBatteryStatus = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
): Promise<BatteryStatus[]|null> => {
  const { [G.BLUETOOTH]: bluetoothAdapter } = module[G.ADAPTER]
  const { sensor } = module[G.MODEL][G.CHILDREN]
  const { value: { name } } = sensor[G.CACHE]
  const peripheral = bluetoothAdapter[G.GROUP][name]

  if (!peripheral) {
    console.log('getBatteryStatus:No peripheral')
    return null
  }

  try {
    const response = await peripheral[G.API].send(GET_STAT)

    const statusList = listBatteryStatus(module, component, null)
    const sortedStatusList = statusList.toSorted((s1, s2) => (String(s2.value) > String(s1.value) ? 1 : -1))
    const status = sortedStatusList.find(status => response.c >= status.value)!

    return [{ ...status, value: `${response.c} %` }]
  } catch (e) {
    console.warn('getBatteryStatus:Cannot obtain battery status', e)
    return null
  }
}

export default curry(getBatteryStatus)
